import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { MenuCourse } from './models/course';
import { CourseRestorePayload, MenuBook, MenuBookDeletePayload, MenuBookRestorePayload } from './models/menuBook';

const menuBookService = {
  getItem(id: number): Promise<CommonResponse<MenuBook>> {
    const url = `/menubook/${id}`;
    return axiosClient.get(url);
  },
  add(payload: Partial<MenuBook>): Promise<CommonResponse<any>> {
    const url = '/menubooks';
    return axiosClient.post(url, payload);
  },
  update(id: number, payload: Partial<MenuBook>): Promise<CommonResponse<any>> {
    const url = `/menubook/${id}`;
    return axiosClient.patch(url, payload);
  },
  delete(payload: MenuBookDeletePayload[]): Promise<CommonResponse<any>> {
    const url = `/menubooks`;
    return axiosClient.delete(url, { data: payload });
  },
  restoreCourse(payload: CourseRestorePayload): Promise<CommonResponse<any>> {
    const url = `/menubooks/restore-course`;
    return axiosClient.patch(url, payload);
  },
  restoreMenuBook(payload: MenuBookRestorePayload): Promise<CommonResponse<any>> {
    const url = `/menubooks/restore-menu-book`;
    return axiosClient.patch(url, payload);
  },
  getTargetMenus(id: number): Promise<CommonResponse<MenuCourse[]>> {
    const url = `/menubook/${id}/get-target-menus`;
    return axiosClient.get(url);
  },
};

export default menuBookService;
